import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(2),
  },
}))

export default useStyles
